//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myPostAction from '../action/myPostAction';
import * as helpAction from '../action/helpAction';
//Material-ui

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import Dialog from '@material-ui/core/Dialog';

import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
//Add
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ja from 'date-fns/locale/ja'
import moment from 'moment';
import TextareaAutosize from 'react-textarea-autosize';

//Part
import PartPageTitle from './PartPageTitle';
//Dialog
import DialogPostPhotoAdd from './DialogPostPhotoAdd';
import DialogConfirm from './DialogConfirm';
//Icon
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

registerLocale('ja', ja);



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      postId: this.props.match.params.id,
      postDate: null,
      postComment: '',
      postCommentInit: '',
      postCommentWordLimit: this.props.config.postCommentWordLimit,
      postPhoto: [],
      postListOpen: (this.props.my.setting.communityPostBan === 1) ? 0 : 1,
      postWebmasterCheck: 0,
      postGoodCountNondisplay: 0,
      postGoodCount: 0,
      postPhotoDialog: false,
      postPhotoEditAnchor: null,
      postPhotoEditId: null,

      postDateValidation: null,
      saveDialogVisible: false,
      saveWebmasterCheckDialogVisible: false,
    }
	}

  componentDidMount() {
    document.title = '投稿の編集 - パートナーズ';
    window.scrollTo(0, 0);
    if (this.state.postId !== 'add') {
      this._postItemGet(this.state.postId);
    }
    else {
      this.setState({
        postDate: new Date()
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.postDate !== this.state.postDate) {
      this.props.myPostDateCheck(moment(this.state.postDate).format('YYYY-MM-DD'), this.state.postId, (data) => {
        if (data.bool === false) {
          this.setState({
            postDateValidation: data.comment,
          });
        }
        else {
          this.setState({
            postDateValidation: null,
          });
        }
      });
    }
  }


  componentWillUnmount() {
    if (this.state.postWebmasterCheck === 0) {
      if (this.state.postCommentInit !== this.state.postComment) {
        this._saveSubmit(0, true);
      }
    }
  }



  _postItemGet(postId) {
    this.props.myPostItemGet(postId, (data) => {
      this.setState({
        postDate: moment(data.post.post_date).toDate(),
        postComment: data.post.post_comment,
        postCommentInit:  data.post.post_comment,
        postPhoto: data.post.photo,
        postListOpen: data.post.post_list_open,
        postGoodCountNondisplay: data.post.post_good_count_nondisplay,
        postWebmasterCheck: data.post.post_webmaster_check,
        postGoodCount: data.post.good_count,
      });
      if (this.props.my.setting.communityPostBan === 1) {
        this.setState({
          postListOpen: 0,
        });
      }
    })
  }


  _onChangePostDate(e) {
    this.setState({postDate: e});
  }

  _renderImg(value, index) {
    return (
      <div
        key={index}
        style={{
          display:'inline-block',
          overflow:'hidden',
          width:'50%',
          maxWidth:'140px'
        }}
      >
        <div style={{margin:'1px'}}>
          <div style={{overflow:'hidden',position:'relative'}} className='round12'>
            <img
              src={value.uri}
              style={{ width:'100%', height:'auto', borderColor:'#FFF', borderWidth:1 }}
              alt=''
            />
            <Fab
              size='small'
              style={{position:'absolute', top:0, right:0}}
              onClick={ (event) => this.setState({postPhotoEditId:value.id, postPhotoEditAnchor:event.currentTarget}) }
            >
              <MoreVertSharpIcon />
            </Fab>
          </div>
        </div>
      </div>
    )
  }

  _photoDel(postPhotoId) {
    this.props.myPostPhotoDel(this.state.postId, postPhotoId, (postId) => {
      this.setState({postId: postId, imgDelId: null});
      this._postItemGet(postId);
    });
  }

  _photoAdd(imageBase64) {
    this.props.myPostSave(
      {
        postId: this.state.postId,
        postDate: moment(this.state.postDate).format('YYYY-MM-DD'),
        postListOpen: this.state.postListOpen,
        postGoodCountNondisplay: this.state.postGoodCountNondisplay,
        postComment: this.state.postComment,
        imageBase64: imageBase64,
        check: 0,
      },
      (postId) => {
        this.setState({postId: postId});
        this._postItemGet(postId);
      }
    );
  }

  _saveSubmit(check, unmount) {
    this.props.myPostSave(
      {
        postId: this.state.postId,
        postDate: moment(this.state.postDate).format('YYYY-MM-DD'),
        postListOpen: this.state.postListOpen,
        postGoodCountNondisplay: this.state.postGoodCountNondisplay,
        postComment: this.state.postComment,
        imageBase64: '',
        check: check,
      },
      (postId) => {
        if (!unmount) {
          this.setState({postId: postId});
          this._postItemGet(postId);
        }
      }
    );
  }

  render() {
    let comp;

    if (this.props.my.setting.profileWebmasterCheck === 0) {
      comp = (
        <div>
          <h2 align='center'>プロフィールのコメントが未登録の為<br/>投稿は作成できません</h2>
        </div>
      )
    }
    else if (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) {
      comp = (
        <div>
          <h2 align='center'>本人証明が申請されていない為<br/>投稿は作成できません</h2>
          <div align='center' style={{padding:'10px'}}>
            <Button
              variant="contained"
              color='secondary'
              onClick={ () => this.props.history.push('/my/proof/person') }
              style={{fontSize:'1.2em'}}
            >
              本人証明を申請する
            </Button>
          </div>
        </div>
      )
    }
    else {
      let checkIcon;
      if (this.state.postWebmasterCheck === 0) {
        checkIcon = (<span className='blue_icon'>未申請</span>);
      }
      else if (this.state.postWebmasterCheck === 1) {
        checkIcon = (<span className='orange_icon'>公開中</span>);
      }
      else if (this.state.postWebmasterCheck === 2) {
        checkIcon = (<span className='purple_icon'>申請中</span>);
      }
      else if (this.state.postWebmasterCheck === 3) {
        checkIcon = (<span className='black_icon'>不承認</span>);
      }


      let postCommentValidComment = null;

      if (this.state.postCommentWordLimit >= this.state.postComment.length) {

      }
      else {
        postCommentValidComment= (<span style={{color:'red'}}>{(this.state.postCommentWordLimit - this.state.postComment.length) * -1}文字オーバー</span>);
      }

      let saveWebmasterCheckButtonDisabled = true;
      if (this.state.postDateValidation) {
        saveWebmasterCheckButtonDisabled = true;
      }
      else if (this.state.postComment.length > 0 && this.state.postCommentWordLimit >= this.state.postComment.length) {
        saveWebmasterCheckButtonDisabled = false;
      }
      else {
        saveWebmasterCheckButtonDisabled = true;
      }

      comp = (
      <div>
        <div style={{padding:'10px', color:'#666'}} align='center'>
          投稿は
          <u className='link' onClick={ () => this.props.helpOpen('id', 315) }>ガイドライン</u>
          のチェック後に公開されます
        </div>
        <div>
          <div style={{padding:'10px'}}>
            <div style={{margin:'10px'}}>
              {checkIcon}
            </div>
            <div style={{margin:'10px'}}>
              <h2>日付</h2>
              <DatePicker
                onChange={ (e) => this._onChangePostDate(e) }
                locale="ja"
                selected={ (this.state.postDate) ? this.state.postDate : new Date() }
                maxDate={new Date()}
                disabled={this.state.postGoodCount > 0 ? true : false}
                customInput={
                  <Button
                    style={{fontSize:'1.2em'}}
                    variant="outlined"
                  >
                    { moment(this.state.postDate).format('YYYY-MM-DD') }
                  </Button>
                }
              />

              {this.state.postGoodCount > 0 && (<div style={{color:'#666'}}>投稿に「いいね」がある為、日付は変更できません</div>) }
              {(this.state.postDateValidation) && (<div style={{color:'red'}}>{this.state.postDateValidation}</div>) }
            </div>
            <div style={{margin:'10px'}}>
              <h2>公開範囲</h2>

              <FormControl variant="outlined">
                <Select
                  value={this.state.postListOpen}
                  onChange={ (e) => this.setState({postListOpen: e.target.value})}
                >
                  <MenuItem
                    value={1}
                    disabled={ (this.props.my.setting.communityPostBan === 1 ? true: false) }
                  >
                    みんなの投稿 &amp; プロフ
                  </MenuItem>
                  <MenuItem
                    value={2}
                    disabled={ (this.props.my.setting.communityPostBan === 1 ? true: false) }
                  >
                    みんなの投稿(異性にだけ公開) &amp; プロフ
                  </MenuItem>
                  <MenuItem
                    value={0}
                  >
                    プロフ
                  </MenuItem>
                </Select>
              </FormControl>

              { (this.state.postListOpen === 1) && (<div style={{color:'#666'}}>「みんなの投稿」と「自分のプロフィール」に掲載されます</div>) }
              { (this.state.postListOpen === 2) && (<div style={{color:'#666'}}>「みんなの投稿(異性会員にだけ公開)」と「自分のプロフィール」に掲載されます</div>) }
              { (this.state.postListOpen === 0) && (<div style={{color:'#666'}}>「自分のプロフィール」だけに掲載されます。日記としてご利用いただけます。</div>) }
            </div>

            <div style={{margin:'10px'}}>
              <h2>いいねの数を表示</h2>
              <FormControl variant="outlined">
                <Select
                  value={this.state.postGoodCountNondisplay}
                  onChange={ (e) => this.setState({postGoodCountNondisplay: e.target.value})}
                >
                  <MenuItem value={0}>表示する</MenuItem>
                  <MenuItem value={1}>表示しない</MenuItem>
                </Select>
              </FormControl>
              { (this.state.postGoodCountNondisplay === 0) && (<div style={{color:'#666'}}>投稿に「いいね」の数が表示されます</div>) }
              { (this.state.postGoodCountNondisplay === 1) && (<div style={{color:'#666'}}>投稿に「いいね」の数は表示されません<br />(投稿の編集ページではいいねの数が確認できます)</div>) }
            </div>

            <div style={{margin:'10px'}}>
              <TextareaAutosize
                value={this.state.postComment}
                className= {(postCommentValidComment) ? "input_red round6" : "input_blue round6"}
                onChange={(e) => this.setState({ postComment: e.target.value})}
                style={{
                  fontSize: '1.2em',
                }}
                minRows={6}
              >
              </TextareaAutosize>
              <div align='right'>{postCommentValidComment} <span>{this.state.postComment.length}/{this.state.postCommentWordLimit}文字</span></div>
            </div>

            <div align='center' style={{margin:'20px'}}>
              {
                (this.state.postPhoto.length < 4) && (
                  <Fab
                    color='primary'
                    onClick={ () => this.setState({postPhotoDialog: true}) }
                  >
                    <AddAPhotoIcon style={{fontSize:'2em'}}/>
                  </Fab>
                )
              }

              <DialogPostPhotoAdd
                open={ this.state.postPhotoDialog }
                close={ () => this.setState({postPhotoDialog: false}) }
                submit={ (imageBase64) => this._photoAdd(imageBase64) }
                postId={ this.state.postId }
              />
            </div>


            <div style={{margin:'10px'}}>
              <div style={{textAlign:'center', fontSize:'1.2em'}}>
                { this.state.postPhoto.length } / 4
              </div>
              <div style={{textAlign:'center'}}>
                {
                  this.state.postPhoto.map(
                    (value, index) => this._renderImg(value, index)
                  )
                }
                <div style={{clear:'both'}}></div>
              </div>

            </div>
          </div>
        </div>
        <div>
          <div align='center' style={{margin:'15px'}}>
            <Button
              variant="outlined"
              color="primary"
              style={{fontSize:'1.2em'}}
              onClick={ () => {
                if (this.state.postWebmasterCheck !== 0) {
                  this.setState({saveDialogVisible: true})
                }
                else {
                  this._saveSubmit(0, false)
                }
              }}
            >
              保存
            </Button>
            &nbsp;
            <Button
              variant="contained"
              color="primary"
              style={{fontSize:'1.2em'}}
              onClick={ () => this.setState({saveWebmasterCheckDialogVisible: true}) }
              disabled={ saveWebmasterCheckButtonDisabled }
            >
              保存して公開申請
            </Button>
          </div>

        </div>

        <Menu
          anchorEl={this.state.postPhotoEditAnchor}
          keepMounted
          open={(this.state.postPhotoEditId)? true: false}
          onClick={ () => this.setState({postPhotoEditId:null, postPhotoEditAnchor:null}) }
        >
          <MenuItem
            onClick={ () => this._photoDel(this.state.postPhotoEditId) }
          >
            削除
          </MenuItem>
        </Menu>

        <DialogConfirm
          open={ (this.state.saveDialogVisible) ? true : false }
          title={'投稿の保存'}
          content={
            (<div>投稿は保存すると未申請に戻ります。公開するには再度申請が必要です。</div>)
          }
          apply={ () => {
            this._saveSubmit(0, false);
            this.setState({saveDialogVisible: false});
          }}
          close={ () => this.setState({saveDialogVisible: null}) }
        />

        <Dialog
          open={this.state.saveWebmasterCheckDialogVisible}
          onClose={ () => this.setState({saveWebmasterCheckDialogVisible: false}) }
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              投稿の公開
            </div>
            <IconButton
              onClick={ () => this.setState({saveWebmasterCheckDialogVisible: false}) }
            >
              <CloseIcon/>
            </IconButton>
          </div>
          <div style={{maxWidth:'400px', margin:'15px'}}>
            投稿は  <u className='link' onClick={ () => this.props.helpOpen('id', 315) }>ガイドライン</u>チェック後に公開されます。<br />
            投稿の承認はサポートの営業時間（10:00～19:00）に行っており、原則24時間以内に確認を行っております。<br />
            掲載まで今しばらくお待ちいただけますようお願い申し上げます。
          </div>
          <div align='center' style={{padding:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{fontSize:'1.2em'}}
              onClick={ () => {
                this._saveSubmit(1, false);
                this.setState({saveWebmasterCheckDialogVisible: false});
              }}
            >
              公開申請する
            </Button>
          </div>
        </Dialog>

      </div>
      )
    }



    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'投稿の編集'}
          onback={ '/my/post/' }
          helpType={ 'category' }
          helpFilter={ 'post' }
        />

        {
          comp
        }

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    config: state.config,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPostAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
